import {Theme} from '../Styles';
import createContext from '../Utils/ContextCreator';
import {useAccessibility} from './Accessibility';

const {ContextProvider: ThemeProvider, useContext: useBaseTheme} = createContext(Theme.LightTheme);

const useTheme = (): ThemeType => {
  const baseTheme = useBaseTheme();
  const {settings} = useAccessibility();

  return settings.highContrast ? Theme.HighContrastTheme : baseTheme;
};

export {ThemeProvider, useTheme};
export type ThemeType = typeof Theme.LightTheme;
